import * as angular from 'angular';
import 'angular-route';
import 'ng-idle';
import 'angular-ui-bootstrap';
import 'angular-animate';
import 'angular-busy';
import 'ng-file-upload';
import 'angular-messages';
import 'angular-aria';
import 'angular-material';
import 'print-js'; // NEEDED for print dialog (Payroll and FM Checks)
import 'jquery-ui/ui/widgets/sortable';
import 'angular-ui-sortable';
import 'ui-select';
import 'angular-smart-table';
import './libs/lrDragNDrop';
import 'angular-google-analytics';
import 'bootstrap';

angular.module('schoolLinqApp', [
	'ngRoute',
	'ngIdle',
	'ui.bootstrap',
	'ngAnimate',
	'cgBusy',
	'ngFileUpload',
	'ngMessages',
	'ngAria',
	'ngMaterial',
	'ui.select',
	'ui.sortable',
	'smart-table',
	'lrDragNDrop',
	'angular-google-analytics',
]);

angular
	.module('schoolLinqApp')
	.config([
		'AnalyticsProvider',
		function (AnalyticsProvider) {
			// Add configuration code as desired
			AnalyticsProvider.setAccount('UA-113781379-2'); //set tracking code
		},
	])
	// adding this run block so that we can attach windows events in ngx and act on them in ajs
	.run([
		'$rootScope',
		'$window',
		function ($rootScope, $window) {
			$window.addEventListener('ngxReloadPage', function () {
				$rootScope.$apply(function () {
					window.location.reload();
				});
			});
		},
	])
	.run(['Analytics', function (Analytics) {}]);

angular.module('schoolLinqApp').config([
	'$routeProvider',
	'$locationProvider',
	'$httpProvider',
	'USER_CLAIMS',
	function ($routeProvider, $locationProvider, $httpProvider, USER_CLAIMS) {
		// Expose XHR requests to server
		$httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		$routeProvider
			.when('/lsb/systemSettings/roles', {
				controller: 'rolesController',
				template: require('@ajs/views/system/roles.html'),
				tabName: 'Roles',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.system],
				},
			})
			.when('/lsb/systemSettings/account', {
				controller: 'accountSetupController',
				template: require('@ajs/views/system/accountSetup.html'),
				tabName: 'Account Setup',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.system],
				},
			})
			.when('/lsb/systemSettings/banking', {
				controller: 'bankingInfoController',
				template: require('@ajs/views/system/bankingInfo.html'),
				tabName: 'Banking Info',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.system],
				},
			})
			.when('/lsb/journalEntries', {
				controller: 'journalController',
				template: require('@ajs/views/fund/accounts/journalEntries.html'),
				tabName: 'Accounts',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/accountActivity', {
				controller: 'accountActivityController',
				template: require('@ajs/views/fund/reports/accountActivity.html'),
				tabName: 'Account Activity Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/payable/vendors', {
				controller: 'vendorsController',
				template: require('@ajs/views/fund/payable/vendors.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/payable/invoices', {
				controller: 'payableInvoicesController',
				template: require('@ajs/views/fund/payable/invoices.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/payable/checkinquiry', {
				controller: 'outstandingCheckInquiryController',
				template: require('@ajs/views/fund/payable/outstandingCheckInquiry.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/payable/setup', {
				controller: 'payableSetupController',
				template: require('@ajs/views/fund/payable/setup.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/invoicesDue', {
				controller: 'invoicesDueController',
				template: require('@ajs/views/fund/reports/invoicesDue.html'),
				tabName: 'Invoices Due Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/salesTaxDue', {
				controller: 'salesTaxDueController',
				template: require('@ajs/views/fund/reports/salesTaxDue.html'),
				tabName: 'Sales Tax Due Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
				},
			})
			.when('/lsb/reports/salesTaxRefund', {
				controller: 'salesTaxRefundController',
				template: require('@ajs/views/fund/reports/salesTaxRefund.html'),
				tabName: 'Sales Tax Refund Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
				},
			})
			.when('/lsb/reports/vendorList', {
				controller: 'vendorListingController',
				template: require('@ajs/views/fund/reports/vendorListing.html'),
				tabName: 'Vendor Listing Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/vendorPayments', {
				controller: 'vendorPaymentsController',
				template: require('@ajs/views/fund/reports/vendorPayments.html'),
				tabName: 'Vendor Payments Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/receivable/invoices', {
				controller: 'receivableInvoicesController',
				template: require('@ajs/views/fund/accountsReceivable/invoices.html'),
				tabName: 'Receivable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/receivable/printsendinvoice', {
				controller: 'printSendARInvoiceController',
				template: require('@ajs/views/fund/accountsReceivable/printSendARInvoice.html'),
				tabName: 'Receivable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/receivable/setup', {
				controller: 'accountsReceivableSetupController',
				template: require('@ajs/views/fund/accountsReceivable/setup.html'),
				tabName: 'Receivable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/customerBalance', {
				controller: 'customerBalanceController',
				template: require('@ajs/views/fund/reports/customerBalance.html'),
				tabName: 'Customer Balance Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/incomeByCustomer', {
				controller: 'incomeByCustomerController',
				template: require('@ajs/views/fund/reports/incomeByCustomer.html'),
				tabName: 'Income By Customer Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/invoiceAging', {
				controller: 'invoiceAgingController',
				template: require('@ajs/views/fund/reports/invoiceAging.html'),
				tabName: 'Invoice Aging Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/purchasing/requisitions', {
				controller: 'purchasingRequisitionsController',
				template: require('@ajs/views/fund/purchasing/requisitions.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/purchasing/purchaseOrders', {
				controller: 'purchasingPurchaseOrdersController',
				template: require('@ajs/views/fund/purchasing/purchaseOrders.html'),
				tabName: 'Payable',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/purchasing/printsendpo', {
				controller: 'printSendPurchaseOrderController',
				template: require('@ajs/views/fund/purchasing/printSendPurchaseOrder.html'),
				tabName: 'Purchasing',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/cash/customers', {
				controller: 'customersController',
				template: require('@ajs/views/fund/cash/customers.html'),
				tabName: 'Cash',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/checkRegister', {
				controller: 'fmCheckRegisterController',
				template: require('@ajs/views/fund/reports/checkRegister.html'),
				tabName: 'Check Register Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/depositRegister', {
				controller: 'depositRegisterController',
				template: require('@ajs/views/fund/reports/depositRegister.html'),
				tabName: 'Deposit Register Report',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/failedCheckPrintLog', {
				controller: 'failedCheckPrintLogController',
				template: require('@ajs/views/fund/reports/failedCheckPrintLog.html'),
				tabName: 'Failed Check Print Log',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/events', {
				controller: 'eventsController',
				template: require('@ajs/views/fund/events/events.html'),
				tabName: 'Events',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/reports/eventProfitLoss', {
				controller: 'eventProfitLossController',
				template: require('@ajs/views/fund/reports/eventProfitLoss.html'),
				tabName: 'Profit and Loss by Event',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
					mode: 'lsb', // LET CONTROLLER KNOW IT'S FOR SCHOOL BOOKKEEPING
				},
			})
			.when('/lsb/utilities/form1099', {
				controller: 'fm1099Controller',
				template: require('@ajs/views/fund/utilities/fm1099.html'),
				tabName: '1099',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
				},
			})
			.when('/lsb/utilities/form1099Override', {
				controller: 'fm1099OverrideController',
				template: require('@ajs/views/fund/utilities/fm1099Override.html'),
				tabName: '1099 Override Earnings',
				data: {
					authorizedRoles: [USER_CLAIMS.authorized, USER_CLAIMS.lsb],
				},
			});

		// ALLOW HOST ANGULAR's Routing System to take over from this point
		$routeProvider.otherwise({
			template: '<div></div>',
		});
	},
]);

angular.module('schoolLinqApp').config([
	'$compileProvider',
	function ($compileProvider) {
		$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|ftp|blob):|data:image\//);
	},
]);

angular.module('schoolLinqApp').config([
	'$httpProvider',
	function ($httpProvider) {
		$httpProvider.interceptors.push('authInterceptorService');
	},
]);

angular.module('schoolLinqApp').config([
	'IdleProvider',
	function (IdleProvider) {
		IdleProvider.idle(1140);
		IdleProvider.timeout(60);
	},
]);

angular.module('schoolLinqApp').run([
	'$templateCache',
	function ($templateCache) {
		// Put in cache the files that have an ng-include in templates
		$templateCache.put('/templates/reports/rcElementRange.html', require('@ajs/templates/reports/rcElementRange.html'));
		$templateCache.put('/templates/reports/rcElementRangeSlimDisplay.html', require('@ajs/templates/reports/rcElementRangeSlimDisplay.html'));
		$templateCache.put('/templates/reports/rcFundRange.html', require('@ajs/templates/reports/rcFundRange.html'));
		$templateCache.put('/templates/reports/rcFundRangeSlimDisplay.html', require('@ajs/templates/reports/rcFundRangeSlimDisplay.html'));
		$templateCache.put('/templates/vendor-autocomplete.html', require('@ajs/templates/vendor-autocomplete.html'));
	},
]);

angular.module('schoolLinqApp').run([
	'$rootScope',
	'Idle',
	'$templateCache',
	'Title',
	'$location',
	'authService',
	function ($rootScope, Idle, $templateCache, Title, $location, authService) {
		$templateCache.get('warning-dialog.tpl.html');
		Idle.watch();

		$rootScope.$on('$routeChangeStart', function (event, next) {
			if (authService.authentication.accessToken && '$$route' in next) {
				if (!authService.canAccessLink(next.$$route.originalPath)) {
					event.preventDefault();
					authService.logOut();
					return;
				}
			}
			$rootScope.title = next.tabName;
			Title.restore();
			$rootScope.mode = next.data ? next.data.mode : null;
			$rootScope.page = next.data ? next.data.page : null;
		});
	},
]);
